import * as React from "react";
import Label from "../Label/Label";
import "./textArea.style.css";

interface IProps {
  className?: string;
  value?: string;
  title?: string;
  icon?: boolean | string;
  errorMessage?: string | boolean;
  onChange?: any;
  name: string;
  placeholder?: string;
  style?: "default" | "transparent";
}

const TextArea = (props: IProps) => {
  const {
    // className,
    value = "",
    title = "",
    errorMessage = false,
    onChange,
    name,
    icon = false,
    placeholder = "",
    style = "default",
  } = props;
  return (
    <Label text={title} icon={icon} errorMessage={errorMessage}>
      <textarea
        rows={10}
        placeholder={placeholder}
        onChange={onChange}
        className={`textArea -${style}`}
        value={value}
        name={name}
      />
    </Label>
  );
};

export default TextArea;
